import React, { useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import TableContainer from 'Common/TableContainer';
import { Link } from 'react-router-dom';
import { Search, Pencil, Info } from 'lucide-react';
import axios from 'axios';

// شبیه‌سازی CountUp
import CountUp from 'react-countup';

// مدل داده
interface SupportItem {
    id: number;
    page_url: string;
    status: number;
    first_name: string;
    last_name: string;
    national_code: string;
    mobile: string;
    description: string;
    created_at: string;
    updated_at: string;
}

const LeaveManageEmployee = () => {

    const [data, setData] = useState<SupportItem[]>([]);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);

    // برای باز کردن مودال و ارسال اطلاعات
    const [showModal, setShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState<SupportItem | null>(null);
    const [note, setNote] = useState("");
    const [reviewStatus, setReviewStatus] = useState("");

    // دریافت اطلاعات از وب‌سرویس
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const res = await axios.get("https://answer.imhh.ir/api/supports"); // آدرس واقعی وب‌سرویس شما
                if (res.data?.status === "ok") {
                    setData(res.data.supports.data);
                  console.error("res:", res);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // فیلتر جستجو
    const filteredData = useMemo(() => {
        return data.filter(item =>
            item.first_name.includes(search) ||
            item.last_name.includes(search) ||
            item.mobile.includes(search) ||
            item.national_code.includes(search)
        );
    }, [search, data]);

    // تابع برای ارسال داده به وب‌سرویس
    const handleSubmit = async () => {
        if (!selectedItem) return;
        try {
            const payload = {
                mobile: selectedItem.mobile,
                description: note,
                review_status: reviewStatus
            };
            await axios.post("https://answexample.com/api/supports/update", payload);
            alert("اطلاعات با موفقیت ارسال شد ✅");
            setShowModal(false);
            setNote("");
            setReviewStatus("");
        } catch (err) {
            alert("خطا در ارسال داده ❌");
        }
    };

    const columns = useMemo(() => [
        {
            header: "ID",
            accessorKey: "id"
        },
        {
            header: "نام",
            accessorKey: "first_name"
        },
        {
            header: "نام خانوادگی",
            accessorKey: "last_name"
        },
        {
            header: "کد ملی",
            accessorKey: "national_code"
        },
        {
            header: "موبایل",
            accessorKey: "mobile"
        },
        {
            header: "توضیح",
            accessorKey: "description"
        },
        {
            header: "وضعیت",
            accessorKey: "status",
            cell: (cell: any) => (
                cell.getValue() === "0" ?
                    <span className="text-yellow-600 bg-yellow-100 px-2 py-1 rounded">بررسی نشده</span> :
                    <span className="text-green-600 bg-green-100 px-2 py-1 rounded">بررسی شده</span>
            )
        },
        {
            header: "عملیات",
            cell: (cell: any) => {
                const row = cell.row.original;
                return (
                    <div className="flex justify-end gap-2">
                        {row.status === 0 && (
                            <button
                                onClick={() => {
                                    setSelectedItem(row);
                                    setShowModal(true);
                                }}
                                className="flex items-center justify-center size-8 rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500"
                            >
                                <Pencil className="size-4" />
                            </button>
                        )}
                        <Link to="#!" className="flex items-center justify-center size-8 rounded-md text-blue-500 bg-blue-100 hover:text-white hover:bg-blue-500">
                            <Info className="size-4" />
                        </Link>
                    </div>
                );
            }
        }
    ], []);

    return (
        <React.Fragment>
            <BreadCrumb title='پشتیبانی کاربران' pageTitle='مدیریت پشتیبانی' />

            <div className="card mt-4">
                <div className="card-body">
                    <div className="mb-4 flex justify-between">
                        <input
                            type="text"
                            placeholder="جستجو..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="border px-3 py-2 rounded w-1/3"
                        />
                    </div>

                    {loading ? (
                        <p>در حال بارگذاری...</p>
                    ) : (
                        <TableContainer
                            isPagination={true}
                            columns={columns}
                            data={filteredData}
                            customPageSize={10}
                        />
                    )}
                </div>
            </div>

            {/* ✅ Modal */}
            {showModal && selectedItem && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white dark:bg-zink-800 rounded-xl w-96 p-6 shadow-lg">
                        <h3 className="text-lg font-semibold mb-4">ثبت بررسی برای {selectedItem.first_name}</h3>

                        <label className="block mb-2 text-sm">توضیحات</label>
                        <textarea
                            className="w-full border rounded p-2 mb-4"
                            rows={4}
                            value={note}
                            onChange={(e) => setNote(e.target.value)}
                        />

                        <label className="block mb-2 text-sm">وضعیت بررسی</label>
                        <select
                            className="w-full border rounded p-2 mb-4"
                            value={reviewStatus}
                            onChange={(e) => setReviewStatus(e.target.value)}
                        >
                            <option value="">انتخاب کنید...</option>
                            <option value="بررسی نشده">بررسی نشده</option>
                            <option value="در حال بررسی">در حال بررسی</option>
                            <option value="بررسی شده">بررسی شده</option>
                        </select>

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={() => setShowModal(false)}
                                className="px-4 py-2 bg-gray-300 rounded"
                            >
                                بستن
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="px-4 py-2 bg-blue-600 text-white rounded"
                            >
                                ارسال
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default LeaveManageEmployee;


// import React, { useEffect, useMemo, useState } from 'react';
// import BreadCrumb from 'Common/BreadCrumb';
// import TableContainer from 'Common/TableContainer';
// import CountUp from 'react-countup';
// import { Link } from 'react-router-dom';


// // Icons
// import { Search, Plus, Pencil, Info, FileBarChart2, CalendarDays, Stethoscope, Anchor } from 'lucide-react';

// // react-redux
// import { useDispatch, useSelector } from 'react-redux';
// import { createSelector } from 'reselect';

// import {
//     getLeaveManageEmployee as onGetLeaveManageEmployee
// } from 'slices/thunk';
// import filterDataBySearch from 'Common/filterDataBySearch';

// const LeaveManageEmployee = () => {

//     const dispatch = useDispatch<any>();

//     const selectDataList = createSelector(
//         (state: any) => state.HRManagment,
//         (state) => ({
//             dataList: state.leaveManageEmployeelist
//         })
//     );

//     const { dataList } = useSelector(selectDataList);

//     const [data, setData] = useState<any>([]);

//     // Get Data
//     useEffect(() => {
//         dispatch(onGetLeaveManageEmployee());
//     }, [dispatch]);

//     useEffect(() => {
//         setData(dataList);
//     }, [dataList]);

//     // Search Data
//     const filterSearchData = (e: any) => {
//         const search = e.target.value;
//         const keysToSearch = ['leaveType', 'reason', 'noOfDays', 'from', 'to', 'approvedBy', 'status'];
//         filterDataBySearch(dataList, search, keysToSearch, setData);
//     };

//     // Table Head Action On Right
//     useEffect(() => {
//         const tableHead = document.querySelectorAll("th");
//         const lastTheadElement = tableHead[tableHead.length - 1];
//         lastTheadElement?.classList.add("ltr:text-right", "rtl:text-left");

//         return () => {
//             lastTheadElement?.classList.remove("ltr:text-right", "rtl:text-left");
//         };
//     });


//     const Status = ({ item }: any) => {
//         switch (item) {
//             case "Approved":
//                 return (<span className="px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent">{item}</span>);
//             case "Pending":
//                 return (<span className="px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-yellow-100 border-transparent text-yellow-500 dark:bg-yellow-500/20 dark:border-transparent">{item}</span>);
//             case "Declined":
//                 return (<span className="px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-red-100 border-transparent text-red-500 dark:bg-red-500/20 dark:border-transparent">{item}</span>);
//             default:
//                 return (<span className="px-2.5 py-0.5 inline-block text-xs font-medium rounded border bg-green-100 border-transparent text-green-500 dark:bg-green-500/20 dark:border-transparent">{item}</span>);
//         }
//     };

//     const columns = useMemo(() => [
//         {
//             header: "#",
//             accessorKey: "id",
//             enableColumnFilter: false
//         },
//         {
//             header: "Leave Type",
//             accessorKey: "leaveType",
//             enableColumnFilter: false,
//         },
//         {
//             header: "Reason",
//             accessorKey: "reason",
//             enableColumnFilter: false,
//         },
//         {
//             header: "No Of Days",
//             accessorKey: "noOfDays",
//             enableColumnFilter: false,
//         },
//         {
//             header: "From",
//             accessorKey: "from",
//             enableColumnFilter: false,
//         },
//         {
//             header: "To",
//             accessorKey: "to",
//             enableColumnFilter: false,
//         },
//         {
//             header: "Approved By",
//             accessorKey: "approvedBy",
//             enableColumnFilter: false,
//         },
//         {
//             header: "Status",
//             accessorKey: "status",
//             enableColumnFilter: false,
//             cell: (cell: any) => (
//                 <Status item={cell.getValue()} />
//             ),
//         },
//         {
//             header: "Action",
//             enableColumnFilter: false,
//             enableSorting: false,
//             cell: (cell: any) => (
//                 <div className="flex justify-end gap-2">
//                     {cell.row.original.status === "Pending" && <Link to="#!" className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-slate-500 bg-slate-100 hover:text-white hover:bg-slate-500 dark:text-zink-200 dark:bg-zink-600 dark:hover:text-white dark:hover:bg-zink-400"><Pencil className="size-4" /></Link>}
//                     <Link to="#!" data-modal-target="leaveOverviewModal" className="flex items-center justify-center size-8 transition-all duration-200 ease-linear rounded-md text-custom-500 bg-custom-100 hover:text-white hover:bg-custom-500 dark:bg-custom-500/20 dark:hover:bg-custom-500"><Info className="size-4" /></Link>
//                 </div>
//             ),
//         }
//     ], []
//     );

//     return (
//         <React.Fragment>
//             <BreadCrumb title='Leave Manage (Employee)' pageTitle='Leaves Manage' />
//             <div className="grid grid-cols-1 gap-x-5 md:grid-cols-2 xl:grid-cols-12">
//                 <div className="xl:col-span-3">
//                     <div className="card">
//                         <div className="flex items-center gap-3 card-body">
//                             <div className="flex items-center justify-center size-12 text-red-500 bg-red-100 rounded-md text-15 dark:bg-red-500/20 shrink-0"><FileBarChart2 /></div>
//                             <div className="grow">
//                                 <h5 className="mb-1 text-16">
//                                     <CountUp end={23} className="counter-value" />
//                                 </h5>
//                                 <p className="text-slate-500 dark:text-zink-200">Total Leave Balance</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="xl:col-span-3">
//                     <div className="card">
//                         <div className="flex items-center gap-3 card-body">
//                             <div className="flex items-center justify-center size-12 text-green-500 bg-green-100 rounded-md text-15 dark:bg-green-500/20 shrink-0"><CalendarDays /></div>
//                             <div className="grow">
//                                 <h5 className="mb-1 text-16">
//                                     <CountUp end={12} className="counter-value" />
//                                 </h5>
//                                 <p className="text-slate-500 dark:text-zink-200">Annual Leave</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="xl:col-span-3">
//                     <div className="card">
//                         <div className="flex items-center gap-3 card-body">
//                             <div className="flex items-center justify-center size-12 text-purple-500 bg-purple-100 rounded-md text-15 dark:bg-purple-500/20 shrink-0"><Stethoscope /></div>
//                             <div className="grow">
//                                 <h5 className="mb-1 text-16">
//                                     <CountUp end={4} className="counter-value" />
//                                 </h5>
//                                 <p className="text-slate-500 dark:text-zink-200">Medical Leave</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="xl:col-span-3">
//                     <div className="card">
//                         <div className="flex items-center gap-3 card-body">
//                             <div className="flex items-center justify-center size-12 rounded-md text-sky-500 bg-sky-100 text-15 dark:bg-sky-500/20 shrink-0"><Anchor /></div>
//                             <div className="grow">
//                                 <h5 className="mb-1 text-16">
//                                     <CountUp end={11} className="counter-value" />
//                                 </h5>
//                                 <p className="text-slate-500 dark:text-zink-200">Remaining Leave</p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="card" id="ordersTable">
//                 <div className="card-body">
//                     <div className="grid grid-cols-1 gap-4 mb-5 lg:grid-cols-2 xl:grid-cols-12">
//                         <div className="xl:col-span-3">
//                             <div className="relative">
//                                 <input type="text" className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200" placeholder="Search for ..." autoComplete="off" onChange={(e) => filterSearchData(e)} />
//                                 <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
//                             </div>
//                         </div>
//                         <div className="xl:col-span-2 xl:col-start-11">
//                             <div className="ltr:lg:text-right rtl:lg:text-left">
//                                 <Link to="/apps-hr-create-leave-employee" type="button" className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"><Plus className="inline-block size-4" /> <span className="align-middle">Add Leave</span></Link>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="overflow-x-auto">
//                         {data && data.length > 0 ?
//                             <TableContainer
//                                 isPagination={true}
//                                 columns={(columns || [])}
//                                 data={(data || [])}
//                                 customPageSize={10}
//                                 divclassName="overflow-x-auto"
//                                 tableclassName="w-full whitespace-nowrap"
//                                 theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:bg-zink-600 dark:text-zink-200"
//                                 thclassName="px-3.5 py-2.5 font-semibold border-b border-slate-200 dark:border-zink-500"
//                                 tdclassName="px-3.5 py-2.5 border-y border-slate-200 dark:border-zink-500"
//                                 PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
//                             />
//                             :
//                             (<div className="noresult">
//                                 <div className="py-6 text-center">
//                                     <Search className="size-6 mx-auto text-sky-500 fill-sky-100 dark:sky-500/20" />
//                                     <h5 className="mt-2 mb-1">Sorry! No Result Found</h5>
//                                     <p className="mb-0 text-slate-500 dark:text-zink-200">We've searched more than 5+ Departments We did not find any Departments for you search.</p>
//                                 </div>
//                             </div>)}
//                     </div>
//                 </div>
//             </div>
//         </React.Fragment>
//     );
// };

// export default LeaveManageEmployee;
